import React, { useContext, useState } from "react";

import PsContext from "../../context";
import { courseName } from "../../utils";
import CheckIcon from "@mui/icons-material/Check";

const AttendanceReportDetailsView = (props) => {
  const context = useContext(PsContext);

  const data = props.dataSource;
  const attData = props.attData;
  let hourCount = context.settingValue("hour_for_attendance_per_day");

  const [currentData, setCurrentData] = useState([]);

  const checkHourExist = (dataObj, hour) => {
    let m = dataObj && dataObj.find((item) => item.hour_value == hour);
    return m && m.hour_value ? true : false;
  };

  const getAttTime = (dataObj, hour) => {
    let m = dataObj && dataObj.find((item) => item.hour_value == hour);
    return (m && m.attendance_time) || "";
  };

  const getEmpName = (dataObj, hour) => {
    let m = dataObj && dataObj.find((item) => item.hour_value == hour);
    return (m && m.employee_name) || "";
  };

  const getAttendanceList = (item) => {
    let rv = [];
    if (item.att_hour_per_day) hourCount = item.att_hour_per_day;

    let m = attData.filter((obj) => obj.course == item.id);

    for (let i = 1; i <= hourCount; i++) {
      rv.push(
        <li className="border-bottom pb-2">
          Hour-{i} - {getAttTime(m, i)}
          <br />
          {getEmpName(m, i)}
          <span className="text-success float-end">
            {checkHourExist(m, i) && (
              <>
                <CheckIcon className="me-1" />
              </>
            )}
          </span>
        </li>
      );
    }
    return rv;
  };

  const handleItemClick = (d) => {
    if (currentData?.id == d.id) setCurrentData([]);
    else setCurrentData(d);
  };

  return (
    <>
      <div className="container-sm py-md-3 ">
        <ul className="page-nav ps-0" style={{ padding: "0 10px" }}>
          {data.map((item, i) => {
            return (
              <li onClick={(e) => handleItemClick(item)}>
                <a className="border-bottom">
                  {courseName(item, true)}
                  {currentData?.id == item.id ? (
                    <i className="iconly-Arrow-Up-2 icli me-0"></i>
                  ) : (
                    <i className="iconly-Arrow-Down-2 icli me-0"></i>
                  )}
                </a>
                {currentData?.id == item.id && (
                  <div
                    className="w-100 bg-silver-50 px-3 py-4"
                    style={{ fontSize: "14px" }}
                  >
                    <ul className="m-0 p-0">{getAttendanceList(item)}</ul>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
        <div className="py-3"></div>
      </div>
    </>
  );
};
export default AttendanceReportDetailsView;
